import React from "react";
import { Logo } from "./logo.jsx";
import { S, anchor, openConsult } from "../site.js";

function FooterCol({ title, links }) {
  return (
    <div className="footer-col">
      <div className="mono" style={{
        fontSize: 11, letterSpacing: "0.1em",
        color: "var(--on-ink-subtle)", marginBottom: 16,
      }}>{title.toUpperCase()}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {links.map((l) => (
          <a key={l.label} className="footer-link" href={l.href} onClick={l.onClick} style={{
            fontSize: 14, color: "var(--on-ink)",
            fontFamily: "var(--font-sans)",
            textDecoration: "none", opacity: 0.85,
          }}>{l.label}</a>
        ))}
      </div>
    </div>
  );
}

function Footer() {
  const startConsultation = openConsult({ source: "footer" });

  return (
    <footer id="footer" className="site-footer" style={{
      background: "var(--ink)", color: "var(--on-ink)",
      padding: "80px 0 32px",
      position: "relative", overflow: "hidden",
    }}>
      <div className="container">
        <div className="grid-footer" style={{
          display: "grid", gridTemplateColumns: "1.45fr repeat(4, 1fr)",
          gap: 40, marginBottom: 64,
        }}>
          <div>
            <a href="/" aria-label="NEXT INNOVATIONS — home" style={{ display: "inline-flex" }}>
              <Logo tone="paper" />
            </a>
            <p style={{
              marginTop: 24, fontSize: 14,
              color: "var(--on-ink-muted)", maxWidth: 280, lineHeight: 1.6,
            }}>
              AI transformation, products, digital systems, and team delivery for teams building in Myanmar.
            </p>
            <div style={{ marginTop: 24, display: "flex", gap: 8 }}>
              <span className="tag tag-ink">Yangon, MM</span>
              <span className="tag tag-ink">Tokyo, JP</span>
            </div>
            <a className="footer-start-link" href={S.contact} onClick={startConsultation}>Start a consultation <span aria-hidden="true">→</span></a>
          </div>
          <FooterCol title="Solutions" links={[
            { label: "AI Transformation to Digital Delivery", href: S.digitalProductSystem },
            { label: "AI Business Solutions", href: S.ai },
            { label: "Product / MVP Development", href: S.mvp },
            { label: "Web System & App Development", href: S.web },
            { label: "AI Marketing & Customer Experience", href: anchor(S.aiMarketing) },
            { label: "AI-Ready Website", href: S.website },
            { label: "Talent & Team Solutions", href: anchor(S.workforce) },
          ]} />
          <FooterCol title="Products" links={[
            { label: "SmartPost AI", href: S.smartpost },
            { label: "NEXT CX AI", href: S.nextCx },
            { label: "Talent Cloud", href: S.talentcloud },
            { label: "NEXT Workforce", href: S.nextWorkforce },
          ]} />
          <FooterCol title="Company" links={[
            { label: "About Us", href: S.about },
            { label: "How We Start", href: anchor(S.howWeStart) },
          ]} />
          <FooterCol title="Contact" links={[
            { label: "Contact us", href: S.contact, onClick: startConsultation },
            { label: "Myanmar Market Support", href: anchor(S.marketSupport) },
            { label: "TikTok Partnership", href: anchor(S.tiktok) },
          ]} />
        </div>
        <div className="hairline-on-ink" />
        <div className="flex items-center between footer-bottom" style={{ paddingTop: 24 }}>
          <div className="mono" style={{
            fontSize: 11, color: "var(--on-ink-subtle)", letterSpacing: "0.08em",
          }}>© 2026 NEXT INNOVATIONS · CRAFTED IN YANGON</div>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
